import moment from 'moment';

const secondsToHHMMSSFFF = (seconds) => {
    const time = moment('2000-01-01T00:00:00:000', 'YYYY-MM-DDTHH:mm:ss:SSS').add(seconds, 'seconds');
    return time.format('HH:mm:ss:SSS');
};
export { secondsToHHMMSSFFF };

const hHMMSSFFFToSeconds = (formatted) => {
    const init = moment('2000-01-01T00:00:00:000', 'YYYY-MM-DDTHH:mm:ss:SSS');
    const time = moment(`2000-01-01T${formatted}`, 'YYYY-MM-DDTHH:mm:ss:SSS');
    return time.diff(init, 'seconds', true);
};
export { hHMMSSFFFToSeconds };
